module.exports = __webpack_public_path__ + "img/phone.ced9c62d.svg";